<template>
  <div class="auth">
    <div class="auth-screen fixed-top">
      <div class="auth-screen-background">
        <div class="auth-screen-background-square"></div>
      </div>
    </div>
    <div class="auth-container fixed-top">
      <Login />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    Login: () => import('@/components/Auth/Login.vue'),
  },
})
export default class Auth extends Vue {}
</script>